<template>
  <div class="ktgl-learning-entry-wrapper">
    <div v-if="loading" class="iy-4">
      <p-row justify-center align-center fill-height>
        <p-progress-linear indeterminate></p-progress-linear>
      </p-row>
    </div>
    <div v-else :class="classList">
      <ktgl-document-image ref="leadImage" cover :ratio="2.9" :picture-id="pictureId"></ktgl-document-image>
      <div class="content">
        <p-card class="px-5">
          <slot name="lead"></slot>
        </p-card>
        <div class="mt-7">
          <slot name="extra"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import ktglDocumentImage from './ktgl-document-image.vue';

  export default Vue.extend({
    name: 'KtglLearningContentLead',
    components: { ktglDocumentImage },
    props: {
      pictureId: { type: [String, Number], default: undefined },
      loading: { type: Boolean, default: false },
    },
    data: () => ({
      hoistedImageEl: undefined as undefined | Element,
    }),
    computed: {
      classList(): Record<string, boolean> {
        return {
          'ktgl-learning-entry': true,
          loaded: !this.loading,
        };
      },
    },
    watch: {
      loading() {
        if (!this.loading) {
          this.$nextTick(() => {
            this.hoistLeadImage();
          });
        }
      },
    },
    beforeDestroy() {
      this.hoistedImageEl?.remove();
    },
    methods: {
      hoistLeadImage() {
        if (this.hoistedImageEl) {
          return;
        }
        const leadImage = this.$refs.leadImage as Vue;
        const imageEl = this._.getElement(leadImage);
        const queue = [] as any[];
        queue.push(imageEl.parentNode);
        let container = undefined as undefined | HTMLElement;
        while (queue.length > 0) {
          const parent = queue.pop();
          if ([...(parent.classList ?? [])].includes('p-container')) {
            container = parent.parentNode;
            break;
          }
          if (parent.parentNode) {
            queue.push(parent.parentNode);
          }
        }
        this.hoistedImageEl = imageEl;
        container?.prepend(imageEl);
      },
    },
  });
</script>
